import md5 from 'js-md5'

/** 用户 Web 端签名密钥，与后端 WebSignSecret 一致 */
const WEB_SIGN_SECRET = process.env.VUE_APP_WEB_SIGN_SECRET || 'FaqSc.2026077@'

function resolveBaseURL() {
  const env = process.env.VUE_APP_API_BASE || '/api'
  if (/https?:\/\//.test(env)) {
    if (/:(8080|8082|8081)\/api/.test(env)) return '/api'
    return env
  }
  return env
}

/** 生成唯一请求 id */
export function createRequestId() {
  return 'req_' + Math.random().toString(36).slice(2, 12) + Date.now().toString(36)
}

/**
 * 用户 Web 端签名鉴权
 * Sign = MD5(毫秒时间戳 + WebSignSecret + 请求id) 小写32位
 */
export function webSignHeaders() {
  const timestamp = String(Date.now())
  const requestId = createRequestId()
  const sign = md5(timestamp + WEB_SIGN_SECRET + requestId).toLowerCase()
  return {
    Timestamp: timestamp,
    'Request-Id': requestId,
    Sign: sign
  }
}

export function apiBase() {
  return resolveBaseURL()
}
